import breakpoints from './tailwind/breakpoints'

export default {
  ...breakpoints
}
